module.exports = __webpack_public_path__ + "static/media/flag-usa.bf087bc6.svg";